/**
 * Custom Form Container
 * @author Kate York
 */

// Utilities
import debug from "debug";
import plugin from '../../lib/plugin';
const log = debug('core/modules/forms/custom-form-container');

const ELEMENT_SELECTOR ='[data-custom-form-continer-block]';
const DOT_NAVIGATION_ELEMENT_SELECTOR = '[data-custom-form-dot-navigation]';
const PREV_BUTTON_ELEMENT_SELECTOR = '[data-f-navigation-previous]';
const SUBMIT_BUTTON_ELEMENT_SELECTOR = '[data-f-type="submitbutton"]';
const PREV_BUTTON_CONTAINER = '[data-prev-button-container]';
const NAV_BUTTONS_CONTAINER = '[data-navigation-buttons-container]';
const NAV_BUTTONS_WRAPPER = '[data-navigation-buttons-wrapper]';
const PRIVACY_CONTAINER = '[data-privacy-content-container]';
const PRIVACY_CONTAINER_ATTR = 'data-privacy-content-container';
const SUBMIT_PRIVACY_CONTAINER_POS = '[data-submit-button-block-privacy-content-container="{0}"]';
const SUBMIT_PRIVACY_CONTAINER = '[data-submit-button-block-privacy-content-container]';
const NAVIGATION_WRAPPER = '[data-navigation-wrapper]';
const PRIVACY_ELEMENT = '[data-privacy-content]';
const SUBMIT_BUTTON_STEP = '[data-f-type="step"]';
const GET_A_QUOTE_BUTTON_SELECTOR = '[data-get-a-quote-button]';
const CURRENT_STEP_INDEX_SELECTOR = '[name="__FormCurrentStepIndex"]';
const STEP_INDEX_SELECTOR = '[data-f-stepindex="{0}"]';
const STEP_NAME_ATTR = 'data-f-element-name';
const DOT_SELECTOR = '.dot';
const SELECTED_DOT_CLASSNAME = 'is-selected';
const HIDE_CLASSNAME = 'invisible';
const MARGIN_CLASSNAME = 'remove-margin-bottom';

class CustomFormContainer {

	constructor (element) {
		this.element = element;
		this.$element = $(element);
		this.elementId = '#' + this.$element.attr('id');
		this.$dotNavigationElement = this.$element.find(DOT_NAVIGATION_ELEMENT_SELECTOR);
		this.$prevButtonElement = this.$element.find(PREV_BUTTON_ELEMENT_SELECTOR);
		this.$submitButtonElement = this.$element.find(SUBMIT_BUTTON_ELEMENT_SELECTOR);
		this.$submitButtonStepElement = this.$submitButtonElement.closest(SUBMIT_BUTTON_STEP);
		this.$prevButtonContainerElement = this.$element.find(PREV_BUTTON_CONTAINER);
		this.$navButtonsContainerElement = this.$element.find(NAV_BUTTONS_CONTAINER);
		this.$navButtonsWrapperElement = this.$element.find(NAV_BUTTONS_WRAPPER);
		this.$navigationWrapperElement = this.$element.find(NAVIGATION_WRAPPER);
		this.$currentStepHiddenElement = this.$element.find(CURRENT_STEP_INDEX_SELECTOR);
		this.$getAQuoteButtonElement = $(GET_A_QUOTE_BUTTON_SELECTOR);

		this.$privacyContainerElement = this.$element.find(PRIVACY_CONTAINER);
		this.privacyPosition = this.$privacyContainerElement.attr(PRIVACY_CONTAINER_ATTR);
		this.$privacyElement = this.$element.find(PRIVACY_ELEMENT);
		this.$submitPrivacyContainerElements = this.$element.find(SUBMIT_PRIVACY_CONTAINER);
		this.$submitPrivacyContainerElement = this.$element.find(SUBMIT_PRIVACY_CONTAINER_POS.replace('{0}', this.privacyPosition));

		this.watch();
	}

	moveContent(isSubmitStep, isFirstStep) {
		this.$submitPrivacyContainerElements.addClass(HIDE_CLASSNAME);
		this.$navigationWrapperElement.addClass(HIDE_CLASSNAME);
		if (isSubmitStep) {
			this.$navButtonsWrapperElement.addClass(HIDE_CLASSNAME);
			this.$prevButtonElement.addClass(HIDE_CLASSNAME);
			this.$prevButtonElement.detach().appendTo(this.$prevButtonContainerElement).removeClass(HIDE_CLASSNAME);
			this.$privacyElement.detach().appendTo(this.$submitPrivacyContainerElement);
			this.$prevButtonElement.removeAttr('disabled');
			this.$submitPrivacyContainerElement.removeClass(HIDE_CLASSNAME);
		}
		else {
			this.$prevButtonElement.detach().appendTo(this.$navButtonsContainerElement).removeClass(HIDE_CLASSNAME);
			this.$privacyElement.detach().appendTo(this.$privacyContainerElement);
			this.$navButtonsWrapperElement.removeClass(HIDE_CLASSNAME);
			this.$navigationWrapperElement.removeClass(HIDE_CLASSNAME);
		}
		if (isFirstStep) {
			this.$prevButtonElement.attr('disabled', 'disabled');
		}
	}

	pushThankYouToGtm() {
		if (typeof (dataLayer) !== 'undefined') {
        	dataLayer.push({
        		'event': 'custom_forms_step_event',
        		'category' : 'Thank you message'
        	});
    	}
	}

	pushSetpToGtm(step, action) {
		if (typeof (dataLayer) !== 'undefined') {
        	dataLayer.push({
        		'event': 'custom_forms_step_event',
        		'category' : 'Screen ' + step,
        		'action' : action
        	});
    	}
	}

	watch() {
		var obj = this;
		if (typeof $$epiforms !== 'undefined') {
			$$epiforms(document).ready(function myfunction() {
				$$epiforms(obj.elementId).on('formsNavigationNextStep formsNavigationPrevStep', function (event) {
					var newStep = 1;
					var eleName ='';

					if (typeof(event.targetStep) !== 'undefined' && typeof(event.targetStep.index) !== 'undefined') {
						newStep = event.targetStep.index;
					}
					if (typeof(event.targetStep) !== 'undefined' && typeof(event.targetStep.elementName) !== 'undefined') {
						eleName = event.targetStep.elementName;
					}

					obj.pushSetpToGtm(newStep, event.type == 'formsNavigationNextStep' ? 'Next' : 'Previous');
					obj.setCurrentStep(newStep, eleName);
				});

				$$epiforms(obj.elementId).on('formsSubmitted', function (event) {
					if (event.isFinalizedSubmission) {
						obj.pushThankYouToGtm();
					}
				});

				$$epiforms(obj.elementId).on('formsSetupCompleted', function (event) {
					var newStep = obj.$currentStepHiddenElement.val();
					var elNameElement = obj.$element.find(STEP_INDEX_SELECTOR.replace('{0}', newStep));
					var eleName = typeof($(elNameElement)) !== 'undefined' ? $(elNameElement).attr(STEP_NAME_ATTR) : '';
					if (newStep > 0) {
						obj.setCurrentStep(newStep, eleName);
					}
				});
			});
		}

		if (typeof(this.$getAQuoteButtonElement) !== 'undefined') {
			this.$getAQuoteButtonElement.on('click', function(e) {
				e.preventDefault();
				obj.$element[0].scrollIntoView();
			});
		}
	}

	setCurrentStep(step, elementName) {
		var obj = this;
		this.$dotNavigationElement.find(DOT_SELECTOR).removeClass(SELECTED_DOT_CLASSNAME);
		var currentStep = this.$dotNavigationElement.find(DOT_SELECTOR).get(step);
		if (typeof(step) !== 'undefined') {
			$(currentStep).addClass(SELECTED_DOT_CLASSNAME);
		}

		var $nextStepEl = this.$element.find('[data-f-element-name="'+elementName+'"]');
		var firstEl = $nextStepEl.find('.field-layout__element').first().find('[class^="c-field"]').first();
		var isSubmitStep = $nextStepEl.find(SUBMIT_BUTTON_ELEMENT_SELECTOR).length > 0;
		var isFirstStep = step == 0;
		if (isSubmitStep) {
			$nextStepEl.addClass(MARGIN_CLASSNAME);
		}
		else {
			$nextStepEl.removeClass(MARGIN_CLASSNAME);
		}

		this.moveContent(isSubmitStep, isFirstStep);

		setTimeout(function(){
			if (typeof(firstEl) !== 'undefined') {
				$(firstEl).focus();
			}
		}, 1);
	}

}

plugin('customFormContainer', CustomFormContainer);

// Export
export function exec () {
	$(document).ready( () => {
		log('binding');
		$(ELEMENT_SELECTOR).customFormContainer();
		log('bound');
	});
}


// WEBPACK FOOTER //
// ./project/client/src/core/modules/forms/custom-form-container.js